<template>
  <v-btn flat icon class="notifications-menu" @click="menu = true" title="Сповіщення">
    <v-badge overlap color="red">
      <span slot="badge" v-if="unreadList.length">{{ unreadList.length }}</span>
      <v-icon>notifications</v-icon>
      <!-- <v-icon>notifications_none</v-icon> -->
    </v-badge>

    <v-menu
      v-model="menu"
      attach=".notifications-menu"
      :close-on-content-click="false"
      class="menu"
      max-height="400"
    >
    <notifications-list :list="list"></notifications-list>
    <!-- <v-list>
      <v-list-tile>
        <v-list-tile-title>Item 1</v-list-tile-title>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-title>Item 2</v-list-tile-title>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-title>Item 3</v-list-tile-title>
      </v-list-tile>
    </v-list> -->
  </v-menu>

  </v-btn>

  <!-- <v-menu offset-y>
        <v-btn color="primary" dark slot="activator">Dropdown</v-btn>
        <v-list>
          <v-list-tile>
            <v-list-tile-title>Item 1</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>Item 2</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> -->
</template>

<script>

import { watchUnread, get as getNotifications, markAllAsRead, READ } from '@/firebase/repositories/notifications';
import NotificationsList from '@/components/NotificationsList';
import { SET_UNREAD_NOTIFICATIONS_LIST } from '@/store/mutationTypes';

export default {
  name: 'NotificationsMenu',
  components: {
    NotificationsList,
  },
  data() {
    return {
      menu: false,
      list: [],
      unreadList: [],
      tailList: [],
      maskAsReadTimer: null,
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth || {};
    },
  },
  watch: {
    menu(opened) {
      if (opened) {
        this.maskAsReadTimer = setTimeout(this.markAllAsRead.bind(this), 2500);
        this.$ga.event('notifications-menu', 'opened');
      } else {
        clearTimeout(this.maskAsReadTimer);
        this.maskAsReadTimer = null;
      }
    },
  },
  mounted() {
    watchUnread(this.auth.uid, this.onUnredNotificationsChanged.bind(this));

    getNotifications(this.auth.uid, READ)
      .then(this.onReadNotificationsLoaded.bind(this));
  },
  methods: {
    onReadNotificationsLoaded(items) {
      this.list = items.concat(this.unreadList).sort(this.sortCallback);
    },
    onUnredNotificationsChanged(items, snapshot) {
      this.unreadList = items;
      this.$store.commit(SET_UNREAD_NOTIFICATIONS_LIST, this.unreadList);

      const list = this.list;

      snapshot.docChanges().forEach((changedDoc) => {
        const index = list.findIndex(item => item.id === changedDoc.doc.id);

        switch (changedDoc.type) {
          case 'added':
            if (index >= 0) {
              list[index] = { id: changedDoc.doc.id, ...changedDoc.doc.data() };
            } else {
              list.push({ id: changedDoc.doc.id, ...changedDoc.doc.data() });
            }
            break;
          case 'removed':
            if (index >= 0) {
              list[index].read = true;
            }
            break;
          default:
        }
      });

      this.list = list.sort(this.sortCallback);
    },
    markAllAsRead() {
      markAllAsRead(this.auth.uid);
    },
    sortCallback(a, b) {
      return a.timestamp > b.timestamp ? -1 : 1;
    },
  },
};

</script>


<style>

.notifications-menu .menu__content {
  min-width: 400px !important;
  left: -364px !important;
  top: 40px !important;
  max-height: 800px;
}

</style>



// WEBPACK FOOTER //
// src/containers/NotificationsMenu.vue